<template>
  <div class="price-table-wrapper products-group" :id="groupname">
    <div class="container">
      <h2 class="section-title">{{ groupname }}</h2>
      <div class="price-description">{{ description }}</div>

      <div class="price-table">
        <table>
          <thead>
            <tr>
              <th>NO</th>
              <th>項目</th>
              <th>單位</th>
              <th>建議售價(新台幣)</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(category, index) in priceTable">
              <tr v-for="(item, itemIndex) in category.items" :key="`${index}-${itemIndex}`">
                <td class="no-cell">{{ item.no }}</td>
                <td class="product-name">{{ item.name }}</td>
                <td class="unit-cell">{{ item.unit || '-' }}</td>
                <td class="price-cell">{{ item.price || '請洽詢' }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productList: {
      type: Object,
      default: () => ({
        groupname: '建議售價',
        group: [],
      }),
    },
  },
  data() {
    return {
      groupname: this.productList.groupname,
      description: this.productList.group[0]?.description || '',
      priceTable: this.productList.group[0]?.priceTable || [],
    };
  },
};
</script>

<style lang="scss" scoped>
.price-table-wrapper {
  padding: 60px 0;
  background-color: #f9f9f9;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .section-title {
    font-size: 32px;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
  }

  .price-description {
    font-size: 16px;
    color: #666;
    margin-bottom: 40px;
    text-align: center;
  }

  .price-table {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    table {
      width: 100%;
      border-collapse: collapse;

      thead {
        background-color: #30AFC6;

        tr th {
          padding: 16px;
          text-align: left;
          font-size: 16px;
          font-weight: 400;
          color: #fff;
          border-bottom: 2px solid #2899af;
        }

        tr th:first-child {
          width: 8%;
          text-align: center;
        }

        tr th:nth-child(2) {
          width: 50%;
        }

        tr th:nth-child(3) {
          width: 12%;
          text-align: center;
        }

        tr th:last-child {
          width: 30%;
          text-align: center;
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #e0e0e0;
          transition: background-color 0.2s;

          &:hover {
            background-color: #f5f5f5;
          }

          &:last-child {
            border-bottom: none;
          }

          td {
            padding: 14px 16px;
            font-size: 14px;
            color: #333;

            &.no-cell {
              text-align: center;
              color: #333;
              font-weight: 500;
            }

            &.product-name {
              color: #555;
            }

            &.unit-cell {
              text-align: center;
              color: #666;
              font-size: 14px;
            }

            &.price-cell {
              text-align: center;
              color: #30AFC6;
              font-size: 15px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    padding: 40px 0;

    .section-title {
      font-size: 24px;
    }

    .price-description {
      font-size: 14px;
      margin-bottom: 30px;
    }

    .price-table table {
      font-size: 12px;

      thead tr th {
        padding: 12px 8px;
        font-size: 14px;
      }

      tbody tr td {
        padding: 10px 8px;
        font-size: 12px;

        &.category-cell {
          font-size: 13px;
        }

        &.price-cell {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
